import { API_CREDENTIALS, API_ENDPOINTS } from "./apiEndpoints";
import axiosClient from "./axiosClient";
import Cookies from "js-cookie"; // Import js-cookie

export const fetchCustomerBookings = () => {
  const token = Cookies.get("token"); // Get the token from cookies
  const customerId = Cookies.get("customerId"); // Get the token from cookies

  return axiosClient.get(API_ENDPOINTS.CUSTOMER_BOOKINGS({ customerId }), {
    headers: {
      "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
      Accept: "application/json",
      "user-token": token, // Use token from cookies
      "Accept-Language": "en",
    },
  });
};
